import React from 'react';

const MobileButtons = ({
  onBack,
  onNext,
  nextName = 'Next',
  backName = 'Back',
}) => {
  return (
    <nav className='fixed inset-x-0 bottom-0 flex justify-center'>
      <div className='mx-auto w-full max-w-xl p-0'>
        <div className='relative flex items-center justify-between gap-4  bg-white px-2 py-3 shadow-[inset_0px_5px_5px_-2px_rgba(0,_0,_0,_0.35)]'>
          <button
            onClick={onBack}
            className='relative flex w-1/2 transform items-center justify-center space-x-2 overflow-hidden rounded-lg bg-[#D7E2E9] text-textprimary px-5 py-2 font-semibold  shadow-md transition border-[1px]  border-buttonprimary focus:outline-none'
            aria-label='Go Back'
          >
            <span>←</span>
            <span>{backName}</span>
          </button>

          <button
            onClick={onNext}
            className='relative flex w-1/2 justify-center transform border-[1px]  border-buttonprimary items-center space-x-2 overflow-hidden rounded-lg bg-buttonprimary  px-5 py-2 font-semibold text-white shadow-md transition focus:outline-none'
            aria-label='Go Next'
          >
            <span>{nextName}</span>
            <span>→</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default MobileButtons;
